class ImageSwap {
  constructor(selector, callback) {
    this.callback = callback;
    this.swapper = selector;
    this.swapperImages = this.swapper.querySelectorAll("[data-image]");
    this.swapperButtons = this.swapper.querySelectorAll("[data-button]");
    this.actionButton = this.swapper.querySelector("[data-action-button]") || null;
    this.initEvents();
  }
  initEvents() {
    this.swapperButtons.forEach((el, i) => {
      el.addEventListener("click", () => {
        this.swapperImages.forEach((image) =>
          image.classList.add("opacity-0", "invisible")
        );
        this.swapperButtons.forEach((btn) =>
          btn.classList.remove("bg-gray-100", "text-se_green")
        );
        this.swapperImages[i].classList.remove("opacity-0", "invisible");
        el.classList.add("bg-gray-100", "text-se_green");
      });
    });
    if (this.actionButton !== null) {
      this.actionButton.addEventListener("click", () => {
        this.callback();
      });
    }
  }
  reset() {
    this.swapperImages.forEach((image) =>
      image.classList.add("opacity-0", "invisible")
    );
    this.swapperImages[0].classList.remove("opacity-0", "invisible");
  }
}

export { ImageSwap };
